import { render, staticRenderFns } from "./BuyItemView.vue?vue&type=template&id=7685b3eb&scoped=true"
import script from "./BuyItemView.vue?vue&type=script&lang=js"
export * from "./BuyItemView.vue?vue&type=script&lang=js"
import style0 from "./BuyItemView.vue?vue&type=style&index=0&id=7685b3eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7685b3eb",
  null
  
)

export default component.exports